const Statuts = {
  BROUILLON: "BROUILLON",
  ENVOYE: "ENVOYE",
  LU: "LU",
} as const;

const Categorie = {
  FONCTIONNEMENT_ORGANISME: "FONCTIONNEMENT_ORGANISME",
  SANTE: "SANTE",
  SECURITE: "SECURITE",
  VICTIMES: "VICTIMES",
} as const;

const Types = {
  [Categorie.VICTIMES]: {
    VIOLENCES_SEXUELLES: "VIOLENCES_SEXUELLES",
    VIOLS: "VIOLS",
    VIOLENCES_PSYCHOLOGIQUES_ET_MORALES: "VIOLENCES_PSYCHOLOGIQUES_ET_MORALES",
    VIOLENCES_PHYSIQUES: "VIOLENCES_PHYSIQUES",
    NON_RESPECT_PRESCRIPTION_MEDICALE: "NON_RESPECT_PRESCRIPTION_MEDICALE",
    PRIVATION_DE_DROIT: "PRIVATION_DE_DROIT",
    NEGLIGENCE_GRAVE_OU_ERREURS_SUCCESSIVES:
      "NEGLIGENCE_GRAVE_OU_ERREURS_SUCCESSIVES",
    MALTRAITANCES_NON_PRECISEES: "MALTRAITANCES_NON_PRECISEES",
    SUICIDE: "SUICIDE",
    TENTATIVE_DE_SUICIDE: "TENTATIVE_DE_SUICIDE",
    AUTRE: "AUTRE__VICTIMES",
  },
  [Categorie.SANTE]: {
    EPIDEMIE: "EPIDEMIE",
    ACCIDENT_CORPOREL: "ACCIDENT_CORPOREL",
    AUTRE: "AUTRE__SANTE",
  },
  [Categorie.SECURITE]: {
    VOLS: "VOLS",
    FUGUE: "FUGUE",
    ACTES_DE_MALVEILLANCE: "ACTES_DE_MALVEILLANCE",
    INTOXICATION_ALIMENTAIRE: "INTOXICATION_ALIMENTAIRE",
    DEPART_DE_FEU: "DEPART_DE_FEU",
    INCENDIE: "INCENDIE",
    INONDATION: "INONDATION",
    AUTRE: "AUTRE__SECURITE",
  },
  [Categorie.FONCTIONNEMENT_ORGANISME]: {
    PROCEDURES_JUDICIAIRES_CONTRE_LE_PERSONNELS:
      "PROCEDURES_JUDICIAIRES_CONTRE_LE_PERSONNELS",
    DEFAILLANCES_TECHNIQUES: "DEFAILLANCES_TECHNIQUES",
    DEFAILLANCE_DE_PERSONNELS: "DEFAILLANCE_DE_PERSONNELS",
    CONFLITS_OU_MENACES_DE_CONFLITS_INTERNES:
      "CONFLITS_OU_MENACES_DE_CONFLITS_INTERNES",
    AUTRE: "AUTRE__FONCTIONNEMENT_ORGANISME",
  },
} as const;

const UpdateTypes = {
  DECLARATION_SEJOUR: "DECLARATION_SEJOUR",
  FILE: "FICHIER",
  TYPE_EVENEMENT: "TYPE_EVENEMENT",
  RENSEIGNEMENT_GENERAUX: "RENSEIGNEMENT_GENERAUX",
  EMAIL_AUTRES_DESTINATAIRES: "EMAIL_AUTRES_DESTINATAIRES",
} as const;

const isTypeActive = (type: string) => {
  return type !== Types[Categorie.VICTIMES].VIOLS;
};

export { Statuts, Categorie, Types, UpdateTypes, isTypeActive };
